import { useCallback } from 'react'

import { User } from '@/models'
import { googleAnalyticsEvent, hotJarEvent, setGoogleAnalyticsUserProperties, setHotJarUserProperties } from '@/utils'


export type EventActionType =
    'button_click' |
    'element_hover' |
    'popup_open' |
    'popup_close' |
    'dropdown_open' |
    'dropdown_close' |
    'video_play' |
    'video_complete' |
    'video_pause' |
    'form_submit' |
    'filter_apply'

export type EventCategoryType =
    'dashboard' |
    'marketing' |
    'index_pages' |
    'profile' |
    'monitoring' |
    'system_history' |
    'warranties' |
    'invoice_records' |
    'adjusted_warranty_summary' |
    'users' |
    'activity' |
    'products' |
    'companies' |
    'certified_providers' |
    'support'

type TrackEventHandler = (
    action: EventActionType,
    category: EventCategoryType,
    label: string,
    value?: number,
    params?: unknown
) => void

export const useAnalytics = (): {
    trackEvent: TrackEventHandler,
    setUser: (user?: User) => void
} => {
    const trackEvent = useCallback<TrackEventHandler>(
        (action, category, label, value = 1, params) => {
            googleAnalyticsEvent({ action, category, label, value }, params)
            hotJarEvent(`Action: ${action}, Category: ${category}, Label: ${label}, Value: ${value}`)
        }, [])

    const setUser = () => {
        setGoogleAnalyticsUserProperties()
        setHotJarUserProperties()
    }

    return { trackEvent, setUser }
}
